import { initializeApp } from "firebase/app";

// Configuración de Firebase
export const firebaseConfig = {
    // -------- prod
    // apiKey: "AIzaSyCjpYTFM5wQhjpBQ6xvh5UZDef51_-Bxso",
    // authDomain: "pagaloop-266ec.firebaseapp.com",
    // databaseURL: "https://pagaloop-266ec.firebaseio.com",
    // projectId: "pagaloop-266ec",
    // storageBucket: "pagaloop-266ec.appspot.com",
    // messagingSenderId: "444095127914",
    // appId: "1:444095127914:web:a662f0d32d12a0725a4513",

    apiKey: "AIzaSyDjuGB-lFJv3C9ZOL84hYsLVx7s0oUvoyw",
    authDomain: "pagaloop-dev.firebaseapp.com",
    databaseURL: "https://pagaloop-dev-default-rtdb.firebaseio.com",
    projectId: "pagaloop-dev",
    storageBucket: "pagaloop-dev.firebasestorage.app",
    messagingSenderId: "250607820022",
    appId: "1:250607820022:web:e16dd1188c58df2ab820d7",
    measurementId: "G-RL8CXG4TG7"

};

// Inicializa Firebase
export const firebaseApp = initializeApp(firebaseConfig);